export const BASE_CLASS_NAME = 'mt-Rating'

export const RATING_STATES = {
  SUCCESS: 'SUCCESS',
  ALREADY_SUBMITTED: 'ALREADY_SUBMITTED',
  EXPIRED: 'EXPIRED',
  PENDING: 'PENDING'
}

export const URL_PARAMS = {
  TRADE_ID: 'tradeId',
  AD_ID: 'dnr',
  TOKEN: 'token'
}

export const getAnswers = ({questions, rating, options}) => {
  const optionsAnswers = options.map(option => {
    return {id: option}
  })

  const answers = [
    {
      question: questions[0]._links.self.href,
      rating,
      scalePoints: 5,
      skipped: false
    },
    {
      question: questions[1]._links.self.href,
      options: optionsAnswers,
      skipped: options.length === 0
    }
  ]

  return answers
}

export const getRatingStateConfig = (state, i18n, urlStaticsImages) => {
  const configs = {
    [RATING_STATES.SUCCESS]: {
      imageUrl: `${urlStaticsImages}illustrations/process-completed-success.svg`,
      notificationText: i18n.t('DEALER_RATINGS.STATES.SUCCESS.NOTIFICATION_TEXT'),
      title: i18n.t('DEALER_RATINGS.STATES.SUCCESS.TITLE'),
      ctaText: i18n.t('DEALER_RATINGS.STATES.SUCCESS.CTA_TEXT')
    },
    [RATING_STATES.ALREADY_SUBMITTED]: {
      imageUrl: `${urlStaticsImages}empty-cases/empty-case-not-allowed.svg`,
      title: i18n.t('DEALER_RATINGS.STATES.CLOSED.TITLE'),
      description: i18n.t('DEALER_RATINGS.STATES.CLOSED.DESCRIPTION'),
      ctaText: i18n.t('DEALER_RATINGS.STATES.CLOSED.CTA_TEXT')
    },
    [RATING_STATES.EXPIRED]: {
      imageUrl: `${urlStaticsImages}illustrations/come-back-soon.svg`,
      title: i18n.t('DEALER_RATINGS.STATES.EXPIRED.TITLE'),
      description: i18n.t('DEALER_RATINGS.STATES.EXPIRED.DESCRIPTION'),
      ctaText: i18n.t('DEALER_RATINGS.STATES.EXPIRED.CTA_TEXT')
    }
  }

  return configs[state]
}
